import { motion } from 'framer-motion'
import type { SlideProps } from '@/components/SlideWizard'
import { useSlideCopy } from '@/lib/i18n'
import { copy } from './Slide2Margaret.copy'

const ease = [0.16, 1, 0.3, 1] as const

export default function Slide2Margaret(_props: SlideProps) {
  const c = useSlideCopy(copy)
  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center text-center px-4 mx-auto max-w-5xl">
      <motion.p
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.15, ease }}
        className="mt-4 max-w-4xl text-xl sm:text-3xl font-normal text-slate-600 leading-[1.35] text-balance"
      >
        {c.bodyBefore}
        <span className="font-semibold text-slate-900">{c.bodyEmphasis}</span>
      </motion.p>
    </div>
  )
}
